export const PX_PER_SECOND = 0.4
export const MIN_BAR_WIDTH = 10
export const PUNCTUAL_WIDTH = 12
export const ROW_HEIGHT = 22
export const BAR_PAD = 6

export const endOf = seg =>
  seg.kind == 'interval'
    ? (seg.start || 0) + (seg.duration || 0)
    : seg.start || 0

export const overlap = (a, b) => a.start < endOf(b) && b.start < endOf(a)

export const assignLanes = intervals => {
  const sorted = [ ...intervals ].sort((a, b) => a.start - b.start)
  const lanes = []

  sorted.forEach(seg => {
    let idx = lanes.findIndex(lane =>
      lane.every(other => !overlap(other, seg)))

    if (idx == -1) {
      lanes.push([])
      idx = lanes.length - 1
    }

    lanes[idx].push(seg)
  })

  return lanes
}

export const laneIds = intervals =>
  assignLanes(intervals).map(lane => lane.map(seg => seg.id))

export const numVal = value => {
  const parsed = parseFloat(value)

  return isNaN(parsed) ? 0 : parsed
}

export const formatTime = sec => {
  const s = Math.round(sec)
  const m = Math.floor(s / 60)
  const r = s % 60

  return `${m}:${String(r).padStart(2, '0')}`
}

export const colorIndex = id => {
  let hash = 0
  for (let i = 0; i < id.length; i++)
    hash = (hash * 31 + id.charCodeAt(i)) % 997

  return hash % 10
}

export const barWidth = seg =>
  seg.kind == 'interval'
    ? Math.max((seg.duration || 0) * PX_PER_SECOND, MIN_BAR_WIDTH)
    : PUNCTUAL_WIDTH

// Bars stay thin horizontally and grow vertically to keep their
// content (label + ingredients) visible: estimate the wrapped rows.
export const segmentHeight = seg => {
  const width = barWidth(seg)
  const ingCount = (seg.ingredientIds || []).length
  const perRow = Math.max(1, Math.floor((width - 16) / 90))
  const lines = (seg.label ? 1 : 0) + Math.ceil(ingCount / perRow)

  return Math.max(26, lines * ROW_HEIGHT + BAR_PAD)
}

export const stripHeight = segs =>
  Math.max(34, ...segs.map(segmentHeight)) + 8

export const axisTicks = maxEnd => {
  let step = 7200
  for (const candidate of [ 60, 300, 600, 1800, 3600 ]) {
    if (maxEnd / candidate <= 12) {
      step = candidate
      break
    }
  }

  const minor = step / 5
  const majorTicks = []
  for (let t = step; t <= maxEnd; t += step)
    majorTicks.push(t)

  const minorTicks = []
  for (let t = minor; t < maxEnd; t += minor) {
    if (t % step != 0)
      minorTicks.push(t)
  }

  return { majorTicks, minorTicks }
}
